import Noti from "./Noti.presenter";
export default Noti;
